import React from "react";
import Layout from "../shared/components/organisms/layout/layout";
import SEO from "../shared/seo";
import '../shared/styles/index.scss'
import Content from "../components/organisms/content/content";
import {graphql} from 'gatsby'

class IndexPage extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      mobile: false
     };
  }

  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState(
        { 
          mobile: true
        }
      );
    }
    window.addEventListener("resize", this.updateDimensions);
    
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
  

  updateDimensions=()=> {
    if (window.innerWidth < 1024){
      this.setState(
        { 
          mobile: true
        }
      )
    }else{
      this.setState(
        { 
          mobile: false
        }
      );
    }
  }

  render() {
    return (
      <Layout 
        mobile={this.state.mobile} 
        title={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaTitulo} 
      >
        <SEO 
          title={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaTitulo} 
          description={this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaDescripcion?.metaDescripcion.split("\n")[0]} 
          image={"https" + this.props.data.allContentfulNolHomeTercerNivel?.nodes?.[0]?.metaImagen?.file?.url}
          url={"/magazin/horoscopo/"}
        />
        <Content
          mobile={this.state.mobile} 
        />

      </Layout>
    )
  }

}

export const query = graphql`

    query GET_CONCURSOS_INFO($locale: String!){
      allContentfulNolHomeTercerNivel(filter: {node_locale: {eq: $locale}, slug: {in: ["horoscopo","horoscopo/"]}}) {
        nodes {
          metaTitulo
          metaDescripcion {
            metaDescripcion
          }
          metaImagen {
            file {
              url
            }
            description
          }
        }
      }
    }

`

export default IndexPage